
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap-redirects/[...slug]",
      function () {
        return require("private-next-pages/sitemap-redirects/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap-redirects/[...slug]"])
      });
    }
  